export default {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        zIndex: 10001,
    },
    modalContent: {
        color: '#454B57',
        textAlign: 'center',
        left: 20,
        right: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'absolute',
        top: 120,
        maxWidth: 728,
        zIndex: 10001,
        background: '#fff',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        outline: 'none',
        boxShadow: '0px 3px 6px 1px rgba(0,0,0,0.35)',
    },
};
